define([
	"dojo/_base/declare",
	"dojo/dom-class",
	"dojo/_base/lang",
	"dojo/on",
	"csi/_base/underscore",
	"csi/action",
	"csi/html",
	"csi/locale",
	"csi/xml"
], function(declare, domClass, lang, on, _, csiAction, html, locale, xml) {

	return declare(null, {
		// summary: Base class for action toolbar plugins

		/** @property {string} parentPluginName - name of parent plugin if in menu */
		//parentPluginName: "",

		// Boolean: controls if disabled items should be shown on the dropdown
		showDisabledItems: false,

		// String: name of plugin - automatically filled in when added to toolbar
		//pluginName: "",

		// Toolbar: pointer to toolbar widget - automatically filled in when added to toolbar
		//actionToolbar: null,

		// Action: action to be performed by plugin
		//defAction: null,

		// Deferred: deferred used to initialize plugin (optional)
		//_deferred: null,

		addTooltip: function(/*_WidgetBase*/w, /*String*/idAction) {
			// summary: add tooltip using title attribute
			var tt = locale.tooltip(idAction);
			if (tt) {
				w.set("title", tt);
			}
		},

		postCreatePlugin: function(/*Context*/ctx) {
			// summary: called right after the plugin was created
			var materialIcon = this.defAction && this.defAction.materialIcon;
			if (materialIcon) {
				if (this.iconNode) {
					html.text(this.iconNode, materialIcon);
				} else {
					console.assert(false, 'Material Icon cannot be used on widget: ' + materialIcon);
				}
			}

			this.own(on(this.domNode, "click", lang.hitch(this, "_onClickAction")));
		},

		canShowPlugin: function() {
			// summary: by default if plugin is validated then it should show
			return true;
		},

		enablePlugin: function(/*Context?*/ctx) {
			// summary: set disabled state of plugin based on action and context; if no context, then just disable
			var b = ctx ? this._hasAccessToAction(ctx) : false;
			this._setDisabled(this, !b);
			return b;
		},

		getView: function() {
			// summary: if on toolbar, then reference view directly
			if (this.actionToolbar) {
				return this.actionToolbar.view;
			}

			// find parent view manually
			var w = this;

			do {
				w = w.domNode ? w.getParent() : null;
			} while (w && !w.isValidView);

			console.assert(!!w, "Toolbar plugin used outside context of view");

			return w;
		},

		/**
		 * Return true or false indicating state of toggle action; if null is returned, then state is undetermined
		 * @param {Context} ctx
		 * @return {boolean|null}
		 */
		isToggledInitially: function(ctx) {
			var a = this.defAction;
			var toggled = null;

			if (a && a.m_nameToggle) {
				if (ctx.push(a.m_path)) {
					toggled = a.isToggledInitially(ctx);
					ctx.pop();
				}
			}

			return toggled;
		},

		onChange: function(/*Object*/value, /*Action*/action) {
			// summary: user callback for when widget value changes (works for many widgets)
			if (action = action || this.defAction) {
				this._invokeAction(action, null, {
					actionValue: value
				});
			}
		},

		onClick: function(/*Event*/e, /*Action*/action, /*Object?*/params) {
			// summary: user callback for when widget is clicked (buttons)
			if (action = action || this.defAction) {
				this._invokeAction(action, e, params);
			}
		},

		/**
		 * Return label to be used on widget for given action
		 * @param {Action} action 
		 */
		_getPluginActionLabel: function(action) {
			return _.escape(action.m_name);
		},

		_hasAccessToAction: function(/*Context*/ctx) {
			// summary: return true if has access to action in given context
			var a = this.defAction;
			if (!a) return true;

			var b;
			var bPop;

			if (a.bActOnSelections) {
				// test view selections for access
				b = ctx.view.canAccessSelections(a);
			} else if (ctx.push(a.m_path)) {
				// use current context
				b = a.hasAccess(ctx);
				bPop = true;
			}

			// update action context for action - set explicitly when rendered, so
			// need to always update when enabled
			if (b) {
				ctx.applyActionContext(this.domNode, a.m_id);
			}

			if (bPop) {
				ctx.pop();
			}

			return b;
		},

		_invokeAction: function(/*Action*/action, /*Event?*/e, /*Object?*/params) {
			// summary: invoke action for widget
			var view = this.getView();

			if (!view.isValidView()) {
				return;
			}

			params = params || {};
			params.actionWidget = this;

			if (this.actionToolbar) {
				// if view has selections and action acts on them, then set url for action
				var fd = view.defView.m_formData;
				if (fd && action.bActOnSelections) {
					params.m_urlNode = xml.nodeGetURL(fd.getSelectedNode());
					params.refNode = view.getRefNodeByUrl(params.m_urlNode);
				}
			}

			csiAction.invoke(view, this.domNode, action, params, e);
		},

		_mixinActionProperties: function(/*_WidgetBase?*/w, /*Action?*/a) {
			// summary: set appearance based on action for buttons and menus
			a = a || this.defAction;
			w = w || this;
			w.params = w.params || {};

			// set label if not icon or if showLabel is not a property
			var bIcon = a.isIcon();
			var bLabel;

			var attr = w.domNode ?
				function(key, value) {w.set(key, value);} :
				function(key, value) {
					w.params[key] = value;
					w[key] = value;
				};

			if (this.showLabel === false) {
				attr("showLabel", false);
			} else if (!this.label) {
				const canHaveLabel = !bIcon || w.showLabelWithIcon || (w.showLabel === undefined);

				if (a.m_name && canHaveLabel) {
					attr("label", this._getPluginActionLabel(a));
					bLabel = true;
				} else {
					attr("showLabel", false);
				}
			}

			if (bIcon) {
				attr("iconClass", a.getIconCSS());
			} else if (a.m_class) {
				if (w.domNode) {
					domClass.add(w.domNode, a.m_class);
				} else {
					attr("class", (w["class"] || "") + " " + a.m_class);
				}
			}

			// set tooltip if different than name
			var tt = bLabel ? a.m_tooltip : a.getDescription();
			if (tt) {
				attr("title", tt);
			}

			// not needed after plugin is created
			if (this.params.actionToolbar) {
				this.params.actionToolbar = null;
			}
		},

		_onClickAction: function(evt) {
			if (this.disabled) {
				evt.preventDefault();
			}
		},

		_setDisabled: function(/*_WidgetBase*/w, /*Boolean*/bDisabled) {
			// summary: set widget disabled status
			if (w && w.domNode) {
				w.set("disabled", Boolean(bDisabled));
			}
		},

		_setSelected: function(/*_WidgetBase*/w, /*Boolean*/bSelected) {
			// summary: Indicate that this node is the currently selected one
			if (w && w.domNode) {
				w.set("selected", Boolean(bSelected));
			}
		},

		_setChecked: function(/*_WidgetBase*/w, /*Boolean*/bChecked) {
			// summary: Indicate that checkbox is Checked or not
			if (w && w.domNode) {
				w.set("checked", Boolean(bChecked));
			}
		}

	});
});